import React from "react";

export function OptionsBone({ className = "", style }) {
  return <span className={`options-sk__bone ${className}`.trim()} style={style} aria-hidden="true" />;
}

export function OptionsPairListSkeleton({ rows = 6 }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <tr key={i}>
          <td>
            <div className="d-flex align-items-center gap-2">
              <OptionsBone className="options-sk__coin" />
              <div className="d-flex flex-column gap-1 flex-grow-1">
                <OptionsBone className="options-sk__line options-sk__line--md" />
                <OptionsBone className="options-sk__line options-sk__line--sm" />
              </div>
            </div>
          </td>
          <td className="text-end">
            <div className="d-flex flex-column align-items-end gap-1">
              <OptionsBone className="options-sk__line options-sk__line--sm" />
              <OptionsBone className="options-sk__line options-sk__line--xs" />
            </div>
          </td>
          <td className="text-end">
            <OptionsBone className="options-sk__line options-sk__line--xs ms-auto" />
          </td>
        </tr>
      ))}
    </>
  );
}

export function OptionsTickerBarSkeleton({ count = 4 }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="options-ticker-item options-sk__ticker">
          <OptionsBone className="options-sk__coin" />
          <div className="options-ticker-info">
            <OptionsBone className="options-sk__line options-sk__line--md" />
            <OptionsBone className="options-sk__line options-sk__line--sm" />
          </div>
        </div>
      ))}
    </>
  );
}

export function OptionsActiveTickerPriceSkeleton() {
  return <OptionsBone className="options-sk__line options-sk__line--price" />;
}

export function OptionsMarginSkeleton() {
  return (
    <>
      <div className="margin-col">
        <div className="margin-row">
          <span className="margin-label dotted">IMR</span>
          <OptionsBone className="options-sk__line options-sk__line--val" />
        </div>
        <div className="margin-row">
          <span className="margin-label dotted">MMR</span>
          <OptionsBone className="options-sk__line options-sk__line--val" />
        </div>
      </div>
      <div className="margin-col">
        <div className="margin-row">
          <span className="margin-label dotted">Margin Balance</span>
          <OptionsBone className="options-sk__line options-sk__line--val" />
        </div>
        <div className="margin-row">
          <span className="margin-label dotted">Available Margin</span>
          <OptionsBone className="options-sk__line options-sk__line--val" />
        </div>
      </div>
    </>
  );
}

export function OptionsExpiryBarSkeleton({ count = 7 }) {
  return (
    <div className="options-sk__expiry-row">
      {Array.from({ length: count }, (_, i) => (
        <OptionsBone key={i} className="options-sk__date-pill" />
      ))}
    </div>
  );
}

export function OptionsChainSkeleton({ rows = 10 }) {
  return (
    <div className="options-sk-chain" aria-hidden="true">
      <div className="options-sk-chain__header">
        <OptionsBone className="options-sk__line options-sk__line--lg" />
        <OptionsBone className="options-sk__line options-sk__line--md" />
      </div>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="options-sk-chain__row">
          <div className="options-sk-chain__side">
            {Array.from({ length: 5 }, (__, j) => (
              <OptionsBone key={j} className="options-sk__cell" />
            ))}
          </div>
          <div className="options-sk-chain__strike">
            <OptionsBone className="options-sk__line options-sk__line--strike" />
          </div>
          <div className="options-sk-chain__side">
            {Array.from({ length: 5 }, (__, j) => (
              <OptionsBone key={j} className="options-sk__cell" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
